<template>
    <div>registration details</div>
</template>
